var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeadIconYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3332 13V11.6667C12.3332 10.9594 12.0522 10.2811 11.5521 9.78105C11.052 9.28095 10.3737 9 9.6665 9H4.33317C3.62593 9 2.94765 9.28095 2.44755 9.78105C1.94746 10.2811 1.6665 10.9594 1.6665 11.6667V13",
    stroke: "#806000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99967 6.33333C8.47243 6.33333 9.66634 5.13943 9.66634 3.66667C9.66634 2.19391 8.47243 1 6.99967 1C5.52692 1 4.33301 2.19391 4.33301 3.66667C4.33301 5.13943 5.52692 6.33333 6.99967 6.33333Z",
    stroke: "#806000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadIconYellow);
export default __webpack_public_path__ + "static/media/lead-icon-yellow.df47dca22234d8763922e993dc7f3c66.svg";
export { ForwardRef as ReactComponent };